module.exports = __webpack_public_path__ + "img/15.641e8080.svg";